import { action, computed, makeObservable, observable } from 'mobx';
import * as utils from '../../helpers/utils';
import { getContactFullName, getContactInitials } from '../../helpers/contactHelpers';

class Contact {
  _id;

  @observable DisplayName;

  @observable FirstName;

  @observable LastName;

  @observable CompanyName;

  @observable ContactType; // ref ContactType

  @observable PhoneNumbers; // ref PhoneNumber

  @observable Emails;

  @observable FetchedEmails;

  @observable CpUsername;

  @observable PushNotificationToken; // ref PushNotificationToken

  @observable Address;

  @observable IsDeleted;

  @observable ClearNotificationsFrom;

  constructor(incObject, store) {
    makeObservable(this);

    this._id = incObject._id ? incObject._id : utils.generateGuid();
    this.DisplayName = incObject.DisplayName || '';
    this.FirstName = incObject.FirstName || '';
    this.LastName = incObject.LastName || '';
    this.CompanyName = incObject.CompanyName || '';
    this.ContactType = store.contactTypeStore.UpsertAndGet(incObject.ContactType) || null;
    this.PhoneNumbers = incObject.PhoneNumbers
      ? store.phoneNumberStore.UpsertAndGet(incObject.PhoneNumbers)
      : [];
    this.Emails = incObject.Emails ? store.emailStore.UpsertAndGet(incObject.Emails) : [];
    this.FetchedEmails = incObject.FetchedEmails || null;
    this.CpUsername = incObject.CpUsername || null;
    this.PushNotificationToken = incObject.PushNotificationToken
      ? store.pushNotificationTokenStore.UpsertAndGet(incObject.PushNotificationToken)
      : [];
    this.Address = incObject.Address || null;
    this.IsDeleted = incObject.IsDeleted || false;
    this.ClearNotificationsFrom = incObject.ClearNotificationsFrom || null;
  }

  /* eslint-disable */
  @action static UpdateObject(incObject, oldObject, rootStore) {
    if (incObject.IsDeleted) {
      rootStore.contactStore.contacts = rootStore.contactStore.contacts.filter(
        (f) => f._id !== incObject._id
      );
      return null;
    }

    oldObject.DisplayName = incObject.DisplayName;
    oldObject.FirstName = incObject.FirstName;
    oldObject.LastName = incObject.LastName;
    oldObject.CompanyName = incObject.CompanyName;
    oldObject.ContactType = rootStore.contactTypeStore.UpsertAndGet(incObject.ContactType);
    oldObject.PhoneNumbers = rootStore.phoneNumberStore.UpsertAndGet(incObject.PhoneNumbers);
    oldObject.Emails = rootStore.emailStore.UpsertAndGet(incObject.Emails);
    oldObject.FetchedEmails = incObject.FetchedEmails || null;
    oldObject.CpUsername = incObject.CpUsername;
    oldObject.PushNotificationToken = rootStore.pushNotificationTokenStore.UpsertAndGet(
      incObject.PushNotificationToken
    );
    oldObject.Address = incObject.Address;
    oldObject.IsDeleted = incObject.IsDeleted;
    oldObject.ClearNotificationsFrom = incObject.ClearNotificationsFrom;
    return oldObject;
  }
  /* eslint-enable */

  @computed get getFullName() {
    return getContactFullName(this);
  }

  @computed get getIsSupport() {
    return this?.ContactType.TypeId === utils.ContactTypeEnum.Support.TypeId;
  }

  @computed get getInitials() {
    return getContactInitials(this);
  }
}

export default Contact;
